<template>
<div class="contentBox liveLaunchPage">
    <div class="pageTitle">
        <!--<h1>发起直播</h1>-->
        <el-steps :active="1" simple finish-status="wait" style="padding-left: 0">
            <el-step title="编辑" icon="el-icon-edit" @click.native="jumpNavPage('/live/edit')"></el-step>
            <el-step title="发起直播" icon="el-icon-video-play"></el-step>
            <el-step title="分享" icon="el-icon-share" @click.native="jumpNavPage('/live/share')"></el-step>
            <el-step title="监控统计" icon="el-icon-data-analysis" @click.native="jumpNavPage('/live/statistics')"></el-step>
            <el-step title="录播" icon="el-icon-video-camera" @click.native="jumpNavPage('/live/history')"></el-step>
        </el-steps>
    </div>
    <div class="advanceds">
        <div class="title">
            <span>方式一：采用 Quicklive 直播客户端</span>
        </div>
        <div class="advancedInfo">
            <p class="liveTips">使用Quicklive发起直播，使用账号登录后，选择直播频道，启动直播即可。</p>
            <!--<button class="downloadBtn">下载Windows客户端</button>-->
            <div class="qrcodeBoxLive">
                <div class="downloadQrcode">
                    <el-link href="/downloads/quicklive_1.0.10.9.zip" target="_blank" :underline="false">
                    <img src="../../assets/windows.png" alt="" />
                    </el-link>
                    Windows 客户端
                </div>
                <!--<div class="downloadQrcode">
                    <img src="../../assets/qrcode1.svg" alt="" />鸿蒙/安卓 APP
                </div>
                <div class="downloadQrcode">
                    <img src="../../assets/qrcode1.svg" alt="" />iOS APP
                </div>-->
            </div>
        </div>
    </div>
    <div class="advanceds">
        <div class="title">
            <span>方式二：采用第三方推流工具</span>
        </div>
        <div class="advancedInfo">
            <div class="infoItem">
                <span class="label">有效小时</span>
                <el-input placeholder="请输入内容" :style="{ width: '287px' }" v-model="hours">
                    <el-button slot="append" type="primary" @click="genPushAddress">生成</el-button>
                </el-input>
            </div>
            <div class="infoItem">
                <span class="label">服务器：</span>
                <el-input placeholder="输入小时数后按生成按钮" class="w600" v-model="serverAddress">
                    <el-button slot="append" type="primary" v-clipboard:copy="serverAddress" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </el-input>
            </div>
            <div class="infoItem">
                <span class="label">串流密钥</span>
                <el-input placeholder="输入小时数后按生成按钮" class="w600" v-model="streamKey">
                    <el-button slot="append" type="primary" v-clipboard:copy="streamKey" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </el-input>
            </div>
            <div class="streamTips">
                <p>当使用第三方推流器向Quicklive提供直播信号时，使用这里指定的频道直播地址。因直播地址含有效期<br />鉴权，请先输入地址有效时长，然后点击【生成】按钮；如需扫码输入推流地址，请点
                    <el-popover
                            placement="bottom"
                            title="扫码输入"
                            width="240"
                            trigger="click">
                        <div ref="addressQr" style="padding: 10px">请先点击生成按钮。</div>
                        <el-button slot="reference" type="primary" style="margin-left: 8px"><i class="fa fa-qrcode" style="margin-right: 8px; font-size: 16px"/>扫码输入</el-button>
                    </el-popover>
                 </p>
                <div class="streamTipsTitle">
                    <img src="../../assets/tipsIcon.svg" alt="" />提醒事项：
                </div>
                <p>
                    1. 为了直播安全，建议生成的推流地址有效期不超过3天； <br />
                    2. 推流地址应妥善保管，Quicklive不为因推流地址泄漏造成的问题负责。
                    <br />
                    <!--3. 如果推流器流服务器和串流分开输入，rtmp://pub.fortune-net.cn/live[cast]为流服务器，后面部分为串流。-->
                </p>
            </div>
        </div>
    </div>

    <div class="advanceds">
        <div class="title">
            <span>方式三：从已有流地址拉流</span>
        </div>
        <div class="advancedInfo">
            <div class="streamTips">
                <p>当直播信号已经存在，可使用拉流任务由Quicklive在指定时间去获取信号源进行直播。<br />注意：在直播频道拉流期间，请勿再向频道推送直播流。</p>
            </div>
            <button class="streamBtn" @click="addTask">新增拉流</button>
            <div class="liveLanchHistoryBox">
                <template v-for="(item, index) in pullTasks">
                    <div class="liveLanchHistoryItem" :key="item.taskId">
                        <div class="date">{{item.start}} 至 {{item.end}}
                            <div class="doing" v-if="item.status === 'LIVING'">
                                <img src="../../assets/start1.svg" alt="" />正在直播
                            </div>
                            <div class="coming" v-if="item.status === 'IDLE'">
                                <img src="../../assets/start2.svg" alt="" />{{item.gap}}
                            </div>
                        </div>
                        <p class="desc">信号源：{{item.sourceUri}}</p>
                        <p class="desc">备注：{{item.memo}}</p>
                        <p class="desc" v-if="item.status === 'LIVING'">状态：正在直播</p>
                        <p class="desc" v-if="item.status === 'IDLE'">状态：尚未开始</p>
                        <p class="desc" v-if="item.status === 'FINISHED'">已经结束</p>
                        <p class="desc" v-if="item.status === 'FAILED'">执行失败</p>
                        <div class="line" v-if="index !== (pullTasks.length-1)"></div>
                        <div class="actionBtn">
                            <el-button icon="el-icon-edit" circle v-if="!['LIVING','FINISHED'].includes(item.status)" @click="editTask(item)"></el-button>
                            <el-popconfirm v-if="item.status !== 'LIVING'" title="确定要删除任务吗？" @confirm="deleteTask(item)">
                                <el-button slot="reference" type="danger" icon="el-icon-delete" circle></el-button>
                            </el-popconfirm>
                        </div>
                    </div>

                </template>
                <el-button type="text" title="加载更多" icon="el-icon-more" v-if="pullTasks.length < totalTask" @click="moreTasks"></el-button>
                <div class="listPrompt">
                    <!-- 无列表显示 -->
                    <div class="noListMessIcon NoInformation" v-if="pullTasks.length === 0">暂无信息</div>
                </div>
            </div>
        </div>
    </div>
    <el-dialog title="编辑任务" :visible.sync="dialogVisible" width="600px">
        <el-form :model="currentTask" label-width="100px">
            <el-form-item label="起止时间" >
                <el-date-picker
                        v-model="currentTask.timeRange"
                        type="datetimerange"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        range-separator="至">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="信号源">
                <el-input v-model="currentTask.sourceUri"></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="textarea" v-model="currentTask.memo"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveTask">保 存</el-button>
        </div>
    </el-dialog>
    <div class="advanceds">
        <div class="title">
            <span>附加：直播转推</span>
        </div>
        <div class="advancedInfo">
            <button class="streamBtn" @click="addEdgeTransfer">新增转推</button>
            <el-popover v-if="isVIP"
                    placement="bottom"
                    width="200"
                    trigger="click">
                <el-button v-if="isVIP" @click="addCenterTransfer" type="warning" icon="el-icon-upload2">新增中心转推</el-button>
                <el-button slot="reference" type="text" class="rot"><i class="el-icon-more"></i></el-button>
            </el-popover>
            <div class="liveLanchHistoryBox">
                <template v-for="item in edgeTransferTasks">
                    <div class="liveLanchHistoryItem" :key="item.transferId">
                        <div class="date">{{item.name}}
                            <div class="doing" v-if="item.log && item.log.status === 'TRANSFERRING'">
                                <img src="../../assets/start1.svg" alt="" />正在执行
                            </div>
                        </div>
                        <p class="desc">推流地址：{{item.streamURL}}</p>
                        <p class="desc">有效期：{{item.expireTime}} <el-tag type="info" size="small" v-if="item.expired"><i class="el-icon-watch"></i>已过期</el-tag></p>
                        <div class="actionBtn">
                            <el-button icon="el-icon-edit" circle v-if="!(item.log) || item.log.status !== 'TRANSFERRING' " @click="editEdgeTransfer(item)"></el-button>
                            <el-popconfirm v-if="!(item.log) || item.log.status !== 'TRANSFERRING'" title="确定要删除直播转发吗？" @confirm="deleteEdgeTransfer(item)">
                                <el-button slot="reference" type="danger" icon="el-icon-delete" circle></el-button>
                            </el-popconfirm>
                        </div>
                    </div>

                </template>
                <template v-for="item in centerTransferTasks">
                    <div class="liveLanchHistoryItem" :key="item.transferId">
                        <div class="date">{{item.name}}
                            <div class="doing" v-if="item.status === 'LIVING'">
                                <img src="../../assets/start1.svg" alt="" />正在执行
                            </div>
                        </div>
                        <p class="desc">推流地址：{{item.streamURL}}</p>
                        <p class="desc">有效期：{{item.startTime}} 至 {{item.endTime}}</p>
                        <div class="actionBtn">
                            <el-button icon="el-icon-edit" circle @click="editCenterTransfer(item)"></el-button>
                            <el-popconfirm title="确定要删除转发任务吗？" @confirm="deleteCenterTransfer(item)">
                                <el-button slot="reference" type="danger" icon="el-icon-delete" circle></el-button>
                            </el-popconfirm>
                        </div>
                    </div>

                </template>
            </div>
            <div class="streamTips">
                <div class="streamTipsTitle">
                    <img src="../../assets/tipsIcon.svg" alt="" />提醒事项：
                </div>
                <p>
                    1. 直播转推指频道开始直播后，Quicklive自动向第三方平台推流； <br />
                    2. 必须提供第三方平台在有效期内的有效地址，因为地址无效而产生的费用，Quicklive不退还；<br />
                    3. 直播转推必须在直播前设置才有效；<br />
                    4. 普通用户每个频道只提供一道直播转推，VIP不限；<br />
                    5. 编辑和删除不影响已经启动转推的任务，需要重新启动直播才会生效，VIP可通过中心转推功能临时增加推流任务。<br />
                </p>
            </div>
        </div>
    </div>
    <el-dialog title="编辑直播转推" :visible.sync="dialogEdgeTransferVisible" width="600px">
        <el-form :model="currentEdgeTransfer" label-width="100px">
            <el-form-item label="名称">
                <el-input v-model.trim="currentEdgeTransfer.name"></el-input>
            </el-form-item>
            <el-form-item label="推流地址">
                <el-input v-model.trim="currentEdgeTransfer.streamURL"></el-input>
            </el-form-item>
            <el-form-item label="有效时长">
                <el-input-number v-model="edgeTransferDuration"></el-input-number>&nbsp;分钟
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogEdgeTransferVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveEdgeTransfer">保 存</el-button>
        </div>
    </el-dialog>
    <el-dialog title="编辑中心转推" :visible.sync="dialogCenterTransferVisible" width="600px">
        <el-form :model="currentCenterTransfer" label-width="100px">
            <el-form-item label="名称">
                <el-input v-model.trim="currentCenterTransfer.name"></el-input>
            </el-form-item>
            <el-form-item label="推流地址">
                <el-input v-model.trim="currentCenterTransfer.streamURL"></el-input>
            </el-form-item>
            <el-form-item label="时间范围">
                <el-date-picker
                        v-model="currentCenterTransfer.timeRange"
                        type="datetimerange"
                        :append-to-body="false"
                        popper-class="time-date-picker"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        range-separator="至">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogCenterTransferVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveCenterTransfer">保 存</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
    import common from '../../common.vue';
    import moment from 'moment';
    import 'moment/locale/zh-cn';
    import QRCode from "qrcodejs2"

    const PAGE_SIZE = 5;
    const SAVE_TRANSFER_MAPPER = {
        "0": "成功",
        "1": "数据无效",
        "2": "访问被拒绝",
        "3": "转推已达上限",
        "4": "正在转推，不允许修改"
    };
    const DEL_TRANSFER_MAPPER = {
        "0": "成功",
        "1": "数据无效",
        "2": "访问被拒绝",
        "3": "正在直播，无法删除"
    };

    export default {
        name: "LiveLaunch",
        data() {
            return {
                isVIP: false,
                channelId: -1,
                hours: '4',
                serverAddress: '',
                streamKey: '',
                fullAddress: '',
                pullTasks: [],
                totalTask: 0,
                // 拉流任务编辑
                dialogVisible: false,
                currentTask: {},
                // 直播转推
                edgeTransferTasks: [],
                dialogEdgeTransferVisible: false,
                currentEdgeTransfer: {},
                edgeTransferDuration: 15,
                dialogCenterTransferVisible: false,
                centerTransferTasks: [],
                currentCenterTransfer: {}
            };
        },
        methods: {
            // 复制成功
            onCopy() {
                this.$message({
                    message: '复制成功！',
                    type: 'success'
                })
            },
            // 复制失败
            onError() {
                this.$message({
                    message: '复制失败！',
                    type: 'error'
                })
            },
            deleteHistoryBoxData() {
                //this.historyBoxData.splice(index, 1);
            },
            genPushAddress() {
                let _this = this;
                _this.$axios.post(common._BASE_ + 'channel/genPushStream',
                    this.$qs.stringify({channelId: _this.channelId, hours: _this.hours})).then(function (res) {
                    let r = res.data;
                    if(!r.address){
                        this.$message({
                            message: '生成推流地址失败，请检查频道是否有效及是否欠费',
                            type: 'error'
                        });
                    }else{
                        let ss = r.address.split('/'), key = ss[ss.length - 1];
                        ss.splice(ss.length -1, 1);
                        _this.serverAddress = ss.join('/');
                        _this.streamKey = key;
                        _this.fullAddress = r.address;
                        _this.$refs.addressQr.innerHTML = '';
                        new QRCode(_this.$refs.addressQr, {
                            text: _this.fullAddress,
                            width: 200,
                            height: 200,
                            colorDark: "#000000",
                            colorLight: "#ffffff",
                            correctLevel: QRCode.CorrectLevel.H
                        });
                    }
                });
            },

            // 获取分页任务，index-页码
            getPullTasks(index) {
                let _this = this;
                _this.$axios.post(common._BASE_ + 'pull/getTasks',
                    this.$qs.stringify({channelId: _this.channelId, pageIndex: index, pageSize: PAGE_SIZE})).then(function (res) {
                    let r = res.data;
                    if (r && r.tasks) {
                        _this.pullTasks = _this.pullTasks.concat(_this.formatTasks(r.tasks));
                    }
                    _this.totalTask = r.total;
                });
            },
            formatTasks(tasks){
                let list = tasks || [];
                moment.locale('zh-ch');
                list.forEach(function(item){
                    item.start = moment(item.startTime).format("YYYY-MM-DD HH:mm");
                    item.end = moment(item.endTime).format("YYYY-MM-DD HH:mm");
                    if(item.status === 'IDLE'){
                        item.gap = moment(item.startTime).fromNow();
                    }
                });
                return list;
            },
            // 新增拉流任务
            addTask(){
                this.currentTask = {taskId: -1};
                this.dialogVisible = true;
            },
            // 编辑拉流任务
            editTask(task){
                if(task){
                    task.timeRange = [task.startTime, task.endTime];
                }
                this.currentTask = task || {};

                this.dialogVisible = true;
            },
            // 删除拉流任务
            deleteTask(task){
                let _this = this;
                _this.$axios.post(common._BASE_ + 'pull/remove',
                    this.$qs.stringify({taskId: task.taskId})).then(function (res) {
                    let r = res.data;
                    if(r.code === 0){_this.pullTasks = []; _this.getPullTasks(0);}
                });
            },
            // 保存
            saveTask(){
                // 检查时间
                let t = this.currentTask;
                if(!t.timeRange){
                    this.$notify({
                        title: '警告',
                        message: '请设置拉流任务的时间',
                        type: 'warning'
                    });
                    return;
                }
                let end = t.timeRange[1];
                if(moment(end).diff(moment()) < 0){
                    this.$notify({
                        title: '警告',
                        message: '拉流任务时间已截止，请重新选择',
                        type: 'warning'
                    });
                    return;
                }
                if(!t.sourceUri || t.sourceUri === ''){
                    this.$notify({
                        title: '警告',
                        message: '请输入信号源',
                        type: 'warning'
                    });
                    return;
                }
                let _this = this;
                _this.dialogVisible = false;
                _this.$axios.post(common._BASE_ + 'pull/saveTask',
                    this.$qs.stringify({channelId: _this.channelId,
                        taskId: t.taskId,
                        startTime: moment(t.timeRange[0]).format('YYYY-MM-DD HH:mm:ss'),
                        endTime: moment(t.timeRange[1]).format('YYYY-MM-DD HH:mm:ss'),
                        sourceUri: t.sourceUri,
                        memo: t.memo})).then(function (res) {
                    let r = res.data;
                    if(r.code === 0){_this.pullTasks = []; _this.getPullTasks(0);}
                });
            },
            // 加载更多
            moreTasks(){
                this.getPullTasks(Math.ceil(this.pullTasks.length/PAGE_SIZE));
            },
            // 加载直播转推
            getTransfer(){
                let _this = this;
                _this.$axios.post(common._BASE_ + 'channel/getTransfer',
                    this.$qs.stringify({channelId: _this.channelId})).then(function (res) {
                    let r = res.data;
                    if (r && r.transferTasks) {
                        _this.edgeTransferTasks = r.transferTasks || [];

                    }
                    if(r && r.centerTransferTasks){
                        _this.centerTransferTasks = [];
                        let task, n = moment(new Date());
                        for(let i=0; i<r.centerTransferTasks.length; i++){
                            task = r.centerTransferTasks[i];
                            task.status = moment(task.startTime).isAfter(n)? 'IDLE' : 'LIVING';
                            _this.centerTransferTasks.push(task);
                        }
                    }
                });
            },

            // 从localStorage中获取缓存的用户
            getLocalSponsor(){
                let json = localStorage.getItem('sponsor');
                return json? JSON.parse(json): null;
            },

            // 显示vip按钮
            showVipButton(){
                let sponsor = this.getLocalSponsor();
                this.isVIP = sponsor && sponsor.vip;
            },

            // 新增转推任务
            addEdgeTransfer(){
                let sponsor = localStorage.getItem('sponsor');
                if(sponsor){
                    if(!sponsor.vip && (this.edgeTransferTasks || []).length > 0){
                        this.$notify({
                            title: '警告',
                            message: '不能再创建新的直播转推，如需多路转推，请联系我们成为VIP',
                            type: 'warning'
                        });
                    }else{
                        this.edgeTransferDuration = 120;
                        this.currentEdgeTransfer = {transferId: -1, name: '', channelId: this.channelId};
                        this.dialogEdgeTransferVisible = true;
                    }
                }
            },
            // 保存转推数据
            saveEdgeTransfer(){
                // 检查时间
                let t = this.currentEdgeTransfer;
                if(t.name === ''){
                    this.$notify({
                        title: '警告',
                        message: '请输入转推任务名称',
                        type: 'warning'
                    });
                    return;
                }
                if(!t.streamURL || t.streamURL === ''){
                    this.$notify({
                        title: '警告',
                        message: '请输入推流地址',
                        type: 'warning'
                    });
                    return;
                }
                if(this.edgeTransferDuration < 5){
                    this.$notify({
                        title: '警告',
                        message: '有效时长请至少5分钟',
                        type: 'warning'
                    });
                    return;
                }
                let _this = this, data = Object.assign(t, {duration: _this.edgeTransferDuration});
                _this.dialogEdgeTransferVisible = false;
                _this.$axios.post(common._BASE_ + 'channel/saveEdgeTransfer',
                    this.$qs.stringify(data)).then(function (res) {
                        if(res.data && res.data.code === 0){_this.getTransfer();}
                        else{
                            _this.$notify({
                                title: '警告',
                                message: SAVE_TRANSFER_MAPPER["" + res.data.code],
                                type: 'warning'
                            });
                        }
                });

            },
            // 编辑直播转推
            editEdgeTransfer(transfer){
                this.currentEdgeTransfer = transfer;
                // 根据过期时间重新计算分钟数
                this.edgeTransferDuration = moment(transfer.expireTime).diff(new Date(), 'minutes');
                this.dialogEdgeTransferVisible = true;
            },
            // 删除直播转推任务
            deleteEdgeTransfer(transfer){
                console.info(transfer);
                let _this = this;
                _this.$axios.post(common._BASE_ + 'channel/deleteEdgeTransfer',
                    this.$qs.stringify({transferId: transfer.transferId})).then(function (res) {
                    if(res.data && res.data.code === 0){_this.getTransfer();}
                    else{
                        _this.$notify({
                            title: '警告',
                            message: DEL_TRANSFER_MAPPER["" + res.data.code],
                            type: 'warning'
                        });
                    }
                });
            },

            addCenterTransfer(){
                let sponsor = this.getLocalSponsor();
                console.info(this.channelId);
                if(sponsor){
                    if(!sponsor.vip){
                        this.$notify({
                            title: '警告',
                            message: '只有VIP能够使用中心转推，如需该服务，请联系我们成为VIP',
                            type: 'warning'
                        });
                    }else{
                        this.currentCeneterTransfer = {transferId: -1, name: '', channelId: this.channelId};
                        this.dialogCenterTransferVisible = true;
                    }
                }
            },
            // 保存中心转推任务
            saveCenterTransfer(){
                // 检查时间
                let t = this.currentCenterTransfer;
                if(t.name === ''){
                    this.$notify({
                        title: '警告',
                        message: '请输入转推任务名称',
                        type: 'warning'
                    });
                    return;
                }
                if(!t.streamURL || t.streamURL === ''){
                    this.$notify({
                        title: '警告',
                        message: '请输入推流地址',
                        type: 'warning'
                    });
                    return;
                }
                // 检查推流协议，只支持rtmp
                if(!t.streamURL.toLowerCase().startsWith("rtmp:")){
                    this.$notify({
                        title: '警告',
                        message: '转推仅支持RTMP协议',
                        type: 'warning'
                    });
                    return;
                }
                if(!t.timeRange){
                    this.$notify({
                        title: '警告',
                        message: '请设置转推任务的时间',
                        type: 'warning'
                    });
                    return;
                }
                let end = t.timeRange[1];
                if(moment(end).diff(moment()) < 0){
                    this.$notify({
                        title: '警告',
                        message: '转推任务时间已截止，请重新选择',
                        type: 'warning'
                    });
                    return;
                }
                let _this = this, data = Object.assign(t,
                    {channelId: _this.channelId,
                        startTime: moment(t.timeRange[0]).format('YYYY-MM-DD HH:mm:ss'),
                    endTime: moment(t.timeRange[1]).format('YYYY-MM-DD HH:mm:ss')});
                _this.dialogCenterTransferVisible = false;
                _this.$axios.post(common._BASE_ + 'channel/saveCenterTransfer',
                    this.$qs.stringify(data)).then(function (res) {
                    if(res.data && res.data.code === 0){_this.getTransfer();}
                    else{
                        _this.$notify({
                            title: '警告',
                            message: SAVE_TRANSFER_MAPPER["" + res.data.code],
                            type: 'warning'
                        });
                    }
                });

            },

            // 编辑中心转推
            editCenterTransfer(transfer){
                this.currentCenterTransfer = transfer;
                this.currentCeneterTransfer.timeRange = [transfer.startTime, transfer.endTime];
                this.dialogCenterTransferVisible = true;
            },

            // 删除中心转推任务
            deleteCenterTransfer(transfer){
                console.info(transfer);
                let _this = this;
                _this.$axios.post(common._BASE_ + 'channel/deleteCenterTransfer',
                    this.$qs.stringify({transferId: transfer.transferId})).then(function (res) {
                    if(res.data && res.data.code === 0){_this.getTransfer();}
                    else{
                        _this.$notify({
                            title: '警告',
                            message: DEL_TRANSFER_MAPPER["" + res.data.code],
                            type: 'warning'
                        });
                    }
                });
            },

            jumpNavPage(path) {
                this.$router.push({
                    path: path,
                    params: { cid: this.channelId },
                    query: {cid: this.channelId}
                });
            }
        },
        mounted() {
            let cid = this.$route.params.cid || this.$route.query.cid;
            if (cid && parseInt(cid) > 0) {
                this.channelId = cid;
                this.getPullTasks(0);
                this.getTransfer();
                this.showVipButton();
            }
        }
    };
</script>

<style lang="less">

    .liveLaunchPage {
        .advanceds {
            width: 1210px;
            background: #ffffff;
            border: 1px solid #e8e8e8;
            margin: 15px 0;

            .tipsBox {
                height: 44px;
                margin: 0 25px;
                display: flex;
                align-items: center;
                font-size: 12px;
                font-weight: 400;
                line-height: 26px;
                color: #7e868c;
                border-bottom: 1px dashed #e8e8e8;

                img {
                    margin-right: 6px;
                }
            }

            .title {
                height: 44px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #e9e9e9;
                padding: 0 21px;
                font-size: 16px;
                font-weight: bold;
                color: #221816;

                span::before {
                    content: "";
                    display: inline-block;
                    width: 4px;
                    height: 12px;
                    background: #306ff6;
                    border-radius: 3px;
                    margin-right: 6px;
                }
            }

            .infoItem {
                display: flex;
                align-items: center;
                margin-bottom: 22px;
            }

            .w600 {
                width: 600px;
            }

            .label {
                width: 83px;
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                color: #221816;
            }

            .advancedInfo {
                // height:280px;
                padding: 16px 32px;
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                color: #221816;
            }

            .liveTips {
                font-size: 14px;
                font-weight: 400;
                line-height: 24px;
                color: #33363f;
            }

            .rot{
                transform: rotateZ(90deg);
                color: darkgray;
            }

            .downloadBtn,
            .streamBtn {
                width: 228px;
                height: 40px;
                background: #076eff;
                border-radius: 4px;
                font-size: 16px;
                font-weight: 400;
                color: #ffffff;
                margin-bottom: 10px;
                margin-top: 15px;
            }

            .streamTips {
                font-size: 14px;
                font-weight: 400;
                line-height: 28px;
                color: #33363f;
            }

            .streamTipsTitle {
                display: flex;
                align-items: center;
                font-weight: bold;
                line-height: 26px;
                color: #33363f;
                margin-top: 15px;
                margin-bottom: 10px;

                img {
                    margin-right: 10px;
                }
            }

            .downloadBtn:hover,
            .streamBtn:hover {
                background: #4aa3f8;
            }

            .vipBtn{
                background:#E6A23C;
                margin-left:8px;
            }
            .vipBtn:hover{
                background:#E6A23C;
            }

            .qrcodeBoxLive {
                display: flex;

                .downloadQrcode {
                    width: 138px;
                    height: 160px;
                    background: #ffffff;
                    border: 1px solid #c1c5c5;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    padding-top: 9px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #55565f;
                    margin-right: 10px;

                    span{
                        height: 119px;
                        overflow: hidden;
                    }

                    img {
                        width: 122px;
                        height: 119px;
                        /*margin-bottom: 6px;*/
                    }
                }
            }

            .liveLanchHistoryBox {
                border-top: 1px solid #e4e6e6;
                margin-top: 5px;

                .liveLanchHistoryItem {
                    position: relative;
                    padding-top: 20px;
                    height: 133px;
                    padding-left: 31px;

                    .date {
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 26px;
                        color: #33363f;
                        display: flex;
                        align-items: center;
                    }

                    .doing {
                        width: 73px;
                        height: 20px;
                        background: #dc5986;
                        border-radius: 4px;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 20px;
                        color: #ffffff;
                        text-align: center;
                        margin-left: 26px;

                        img {
                            margin-right: 3px;
                        }
                    }

                    .coming {
                        width: 105px;
                        height: 20px;
                        background: #306ff6;
                        border-radius: 4px;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 20px;
                        color: #ffffff;
                        margin-left: 26px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            margin-right: 3px;
                        }
                    }

                    .actionBtn {
                        position: absolute;
                        right: 0;
                        top: 20px;

                        /*button {
                            width: 50px;
                            height: 25px;
                            background: #ffffff;
                            border: 1px solid #c1c5c5;
                            border-radius: 4px;
                            margin-left: 8px;
                        }

                        button:hover {
                            background: #306ff6;
                            color: #ffffff;
                            border: none;
                        }*/
                    }

                    .desc {
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 26px;
                        color: #7e868c;
                    }

                    .line {
                        width: 1132px;
                        height: 1px;
                        background: #e4e6e6;
                        margin-top: 10px;
                    }
                }

                .liveLanchHistoryItem::before {
                    position: absolute;
                    content: "";
                    width: 1px;
                    height: 133px;
                    background: #e4e6e6;
                    left: 10px;
                    top: 0;
                }

                .liveLanchHistoryItem::after {
                    position: absolute;
                    content: "";
                    width: 14px;
                    height: 14px;
                    background: #f5f6f7;
                    border: 1px solid #c1c5c5;
                    border-radius: 50%;
                    left: 2px;
                    top: 25px;
                }
            }

            .el-input-group__append {
                cursor: pointer;
            }

            .el-input-group__append:hover {
                color: #fff;
                background: #076eff;
            }

            .el-date-editor{
                position: relative;
            }
        }
    }
</style>